export default {
    stores: [],
}
